import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBubble3"><Path d="M11.9994 2C6.47658 2 1.99943 6.47715 1.99943 12C1.99943 13.5227 2.34042 14.9682 2.95088 16.2622L1.7207 22.2566L7.86385 21.1072C9.12532 21.6808 10.5263 22 11.9994 22C17.5223 22 21.9994 17.5228 21.9994 12C21.9994 6.47715 17.5223 2 11.9994 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble3;
